import ClassicExtension from "./ClassicExtension";

export default class OnClickRedirectExtension extends ClassicExtension {

    protected init($root): void {
        $root.find('[data-onclick-redirect]').on('click', e => window.location.href = $(e.currentTarget).data('onclick-redirect'));
    }

}